// extracted by mini-css-extract-plugin
export default {"main_layout":"NotFound_main_layout__aOm-q","main_content":"NotFound_main_content__0k-XI"};